import * as types from './actionTypes'

export const fetchLogin = ({username, password, instance}) => ({
    type: types.LOGIN_FETCH,
    username,
    password,
    instance
})

export const fetchLoginSuccess = (data) => ({
    type: types.LOGIN_FETCH_SUCCESS,
    data
})

export const fetchLoginFailed = () => ({
    type: types.LOGIN_FETCH_FAILED
})

export const fetchAutologin = () => ({
    type: types.AUTOLOGIN_FETCH
})

export const fetchAutologinSuccess = (data) => ({
    type: types.AUTOLOGIN_FETCH_SUCCESS,
    data
})

export const fetchAutologinFailed = () => ({
    type: types.AUTOLOGIN_FETCH_FAILED
})

export const fetchLogout = () => ({
    type: types.LOGOUT_FETCH
})

export const fetchLogoutSuccess = () => ({
    type: types.LOGOUT_FETCH_SUCCESS
})

export const fetchLogoutFailed = () => ({
    type: types.LOGOUT_FETCH_FAILED
})


export const fetchInstances = () => ({
    type: types.INSTANCES_FETCH
})

export const fetchInstancesSuccess = (list, instance) => ({
    type: types.INSTANCES_FETCH_SUCCESS,
    list,
	instance
})

export const fetchInstancesFailed = () => ({
    type: types.INSTANCES_FETCH_FAILED
})

export const fetchRegistration = ({newusername, newpassword, instance}) => ({
    type: types.REGISTRATION_FETCH,
    newusername,
    newpassword,
    instance
})

export const fetchRegistrationSuccess = (data) => ({
    type: types.REGISTRATION_FETCH_SUCCESS,
    data
})

export const fetchRegistrationFailed = () => ({
    type: types.REGISTRATION_FETCH_FAILED
})

export const setUserData = (userdata) => ({
    type: types.SET_USER_DATA,
    userdata
})

export const setUserDataSuccess = (data) => ({
    type: types.SET_USER_DATA_SUCCESS,
    data
})

export const setUserDataFailed = () => ({
    type: types.SET_USER_DATA_FAILED
})

export const changePassword = (pass) => ({
    type: types.CHANGE_PASSWORD,
    pass
})

export const changePasswordSuccess = () => ({
    type: types.CHANGE_PASSWORD_SUCCESS
})

export const changePasswordFailed = () => ({
    type: types.CHANGE_PASSWORD_FAILED
})

export const getCallUrl = () => ({
    type: types.GET_CALL_URL
})

export const getCallUrlSuccess = (url) => ({
    type: types.GET_CALL_URL_SUCCESS,
    url
})

export const getCallUrlFailed = () => ({
    type: types.GET_CALL_URL_FAILED
})

export const setCallUrl = (value) => ({
    type: types.SET_CALL_URL,
    value
})

export const setCallUrlSuccess = (url) => ({
    type: types.SET_CALL_URL_SUCCESS,
    url
})

export const setCallUrlFailed = () => ({
    type: types.SET_CALL_URL_FAILED
})
